module.exports = __webpack_public_path__ + "img/hourglass.0985ef89.svg";